<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
      >
        <v-alert
          border="left"
          color="blue-grey"
          dark
          text
        >
          <strong>{{ user.name }}</strong>, bem-vindo(a) ao sistema
          <strong>{{ appName }}</strong>.
        </v-alert>
        <v-divider class="mb-5" />
        <Widgets
          :title="'Pedidos'"
          :type="''"
          :content="verifyIsEngineer()"
        />
        <Widgets
          v-if="user.profile!=='ENGINEER'"
          :title="'Autovistoria + Laudo de Engenheiro Mecânico'"
          :type="''"
          :content="inspectionWidgets"
        />
        <Widgets
          v-if="user.profile!=='ENGINEER'"
          :title="'Renovação de Registro de Veículo'"
          :type="'RENOVACAO_REGISTRO_VEICULO'"
          :content="validityWidgets"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import GlobalStore from '@/store/modules/global';
  import { APP_NAME } from '@/commons/config';
  import Widgets from '@/components/Widgets/Widgets';

  export default {
    components: {
      Widgets
    },
    data: () => ({
      appName: APP_NAME,
      widgets: [
        {
          title: 'Aguardando Análise',
          icon: 'assignment_return',
          status: ['waiting_analysis'],
          color: 'primary',
          inspection_status: [],
          isEngineer: false

        },
        {
          title: 'Pagamento Pendente',
          icon: 'assignment',
          status: ['pending_payment'],
          color: 'success',
          inspection_status: [],
          isEngineer: false
        },
        {
          title: 'Documentação Pendente',
          icon: 'assignment_late',
          status: ['waiting_documents', 'pending_documents'],
          color: 'warning',
          inspection_status: [],
          isEngineer: false
        },
        {
          title: 'Documentação Pendente ARCE',
          icon: 'assignment_returned',
          status: ['waiting_documents_arce', 'pending_documents_arce'],
          color: 'warning',
          inspection_status: [],
          isEngineer: false
        },
        {
          title: 'Aguardando Análise do Engenheiro',
          icon: 'assignment_returned',
          status: [],
          color: 'warning',
          inspection_status: ['awaiting_engineer_analise'],
          isEngineer: true
        },
        {
          title: 'Não aceito pela ARCE',
          icon: 'assignment_returned',
          status: ['not_accepted_by_arce'],
          color: 'warning',
          inspection_status: [],
          isEngineer: false
        },
        {
          title: 'Cancelado',
          icon: 'cancel',
          status: ['canceled'],
          color: 'error',
          inspection_status: [],
          isEngineer: false
        },
        {
          title: 'Concluído',
          icon: 'assignment_turned_in',
          status: ['approved'],
          color: 'green',
          inspection_status: [],
          isEngineer: false
        }
      ],
      validityWidgets: [
        {
          title: 'A vencer em 30 dias',
          icon: 'event_available',
          status: [],
          color: 'warning',
          inspection_status: [],
          isEngineer: false,
          filters: { expiring_in: 30 }
        },
        {
          title: 'Registros vencidos',
          icon: 'event_busy',
          status: [],
          color: 'error',
          inspection_status: [],
          isEngineer: false,
          filters: { validity_expired: true }
        }
      ],
      inspectionWidgets: [
        {
          title: 'Em Análise Pelo Engenheiro',
          icon: 'assignment_returned',
          status: [],
          color: 'warning',
          inspection_status: ['making_engineer_analise'],
          isEngineer: false
        },
        {
          title: 'Aguardando Análise do Operador',
          icon: 'assignment_returned',
          status: [],
          color: 'warning',
          inspection_status: ['awaiting_operator_analise'],
          isEngineer: false
        },
      ]
    }),
    computed: {
      user: () => GlobalStore.user || {}
    },
    methods: {
      verifyIsEngineer() {
        const { functionalities } = this.user;
        const verifyEngineer = functionalities.includes('inspection_review')
        return this.widgets.filter(w => { return w.isEngineer == verifyEngineer})
      },
    }
  };
</script>

<style lang="scss" scoped>
.v-alert__content {
  font-size: 15px;
  strong {
    font-size: 15px !important;
  }
}
</style>
